export enum EventStatusEnum {
  Created = 1,
  Active,
  Canceled,
  Finished,
  Published
}


